export class Function {
    constructor(id, descripcion) {
        this.id = id;
        this.descripcion = descripcion;
    }
}
